import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { deviceActivatedResponseSchema } from '../types';

export const receiveDeviceActivated = createReceive(
	'device-activated',
	zodContract(deviceActivatedResponseSchema),
);
